<template>
  <div class="text--twoParagraphs" v-html="text"></div>
</template>

<script>

export default {
  name: 'TwoParagraphsText',
  props: {
    text: {
      type: String
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>

